module.exports = __webpack_public_path__ + "assets/img/16.d72599c2.png";